import Cookies from 'js-cookie'
import config from '../../../config'

export const fetchHighlightSeriesList = async ({ status = 'UNKNOWN', pageParam = 1 }) => {
  const params = new URLSearchParams()
  params.append('eventType', 'HIGHLIGHT_SERIES')
  params.append('status', status)
  params.append('page', pageParam)
  params.append('limit', 10)

  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/eventscheduler?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      throw err
    })

  return response
}

export const fetchHighlightSeriesDetail = async (id) => {
  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/eventscheduler/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      throw err
    })

  return response
}

export const createHighlightSeries = async (formData) => {
  const params = new URLSearchParams()
  params.append('payload.start', formData.start)
  params.append('payload.end', formData.end)
  formData.sizes.forEach((size) => {
    params.append('payload.sizes', size)
  })
  params.append('payload.headerImage', formData.headerImage)
  params.append('payload.title', formData.title)
  params.append('payload.description', formData.description)
  params.append('payload.showCountdown', formData.showCountdown)
  params.append('schedule', formData.schedule)

  const url = `${config.apiAdminGateway}/api/v1/admin/eventscheduler?${params.toString()}`

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error('error : ', err)
    })

  return response
}

export const updateHighlightSeries = async (formData) => {
  const params = new URLSearchParams()
  params.append('id', formData.id)
  params.append('remark', formData.remark)

  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/eventscheduler?${params.toString()}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      console.log('error : ', err)
    })

  return response
}
